import { Card, DatePicker, Row, Col } from "antd";
import { ReactComponent as CalendarIcon } from "../../Icons/vuesax/calendar.svg";
import { Dayjs } from "dayjs";

interface DateOfDictationFilterProps {
  selectedDictationDateFrom?: Dayjs | null;
  selectedDictationDateTo?: Dayjs | null;
  onChangeDates: (selectedDictationDateFrom: Dayjs | null, selectedDictationDateTo: Dayjs | null) => void;
}

const DateOfDictationFilter = ({
    selectedDictationDateFrom = null,
    selectedDictationDateTo = null,
    onChangeDates
  }: DateOfDictationFilterProps) => {

  const handleFromChange = (value: any) => {
    onChangeDates(value, selectedDictationDateTo);
  };

  const handleToChange = (value: any) => {
    onChangeDates(selectedDictationDateFrom, value);
  };

  return (
    <Card styles={{ body: { padding: "16px" } }} className={`service-filter-card`} >
      <span className="dictation-filter-title">Date of Dictation</span>
      <Row justify="space-between" align="middle" style={{ marginTop: "10px" }} gutter={[8,12]}>
        <Col xs={24} sm={12} >
          <label htmlFor="date-from-dictation" className="input-label">
            From
          </label>
          <DatePicker
            className="custom-datepicker"
            id="date-from-dictation"
            placeholder="MM/DD/YYYY"
            format="MM/DD/YYYY"
            value={selectedDictationDateFrom}
            suffixIcon={<CalendarIcon className="calendar-icon" />}
            onChange={handleFromChange}
          />
        </Col>
        <Col xs={24} sm={12} >
          <label htmlFor="date-to-dictation" className="input-label">
            To
          </label>
          <DatePicker
            className="custom-datepicker"
            id="date-to-dictation"
            placeholder="MM/DD/YYYY"
            format="MM/DD/YYYY"
            value={selectedDictationDateTo}
            suffixIcon={<CalendarIcon className="calendar-icon" />}
            onChange={handleToChange}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default DateOfDictationFilter;
